import InputNumber from 'primevue/inputnumber';<template>
  <div>
    <Head title="Hisobotlar turini qo'shish" />
    <h1 class="mb-2 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/templates">Hisobot turi</Link>
      <span class="text-indigo-400 font-medium"></span>
    </h1>
    <div class="w-full bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-16 -mr-6 p-8">
          <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full lg:w-1/2" label="title" />
        </div>
        <div class="w-full -mb-8 h-auto -mr-6 p-8">
          <editor
            v-model="form.content"
            lineheight_formats = "8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 26pt 36pt"
            api-key="jzoa1aw0fxv9b966j8jyirek6o6v55dma4c9nrm2expy30ug"
            :init="{
              height: 600,
              plugins: 'advlist autolink  lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste',
              toolbar: 'undo redo | styleselect | forecolor | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | link image | code'
            }"
          />
        </div>


        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!template.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Shablonni o'chirish</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" @click="update">Hisobot turini saqlash</loading-button>
        </div>
        <div class="w-full p-10">
          <button class="text-gray-700 bg-gray-200 border-2 m-3 p-3  w-1/3" tabindex="-1" type="button" @click="showManualModal()">Korxonani izlash</button>
          <button class="text-gray-700 bg-gray-200 border-2 p-3 float-right w-1/3" tabindex="-1" type="button" @click="showFilelModal(true)">
            <icon name="pen" class="mr-2 w-4 h-4" :class="isUrl('templates') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
            Faylni yuklab olish
          </button>
        </div>
      </form>

    </div>


    <Sidebar v-model:visible="manualModal" position="full">
      <Toolbar>
        <template #start>
          <p>You can add multiple numbers</p>
        </template>
        <template #end>
          <InputText placeholder="Enter INN number" v-model="company.inn" />
          <Button label="Search" icon="pi pi-search" @click="searchForCompany" iconPos="right" class="p-button-text p-button-text" />
        </template>
      </Toolbar>
      <div class="w-full h-full bg-gray-200 dark:bg-gray-900 overflow-x-hidden">
        <div class="container mx-auto py-10">
          <Message v-show="notify.show" :severity="notify.severity" :life="5000" :sticky="false">{{ notify.content }}</Message>
          <table class="w-full shadow text-left bg-white dark:bg-gray-800">
            <thead>
            <tr class="border-b border-gray-300 dark:border-gray-700">
              <th class="py-5 sm:pl-10 pl-2 w-1/4 text-base text-gray-800 dark:text-gray-100">Company</th>
              <th class="py-5 w-1/4 text-base text-gray-800 dark:text-gray-100">Address</th>
              <th class="py-5 w-1/4 text-base text-gray-800 dark:text-gray-100 pl-20">Email</th>
              <th class="py-5 w-1/4 text-base text-gray-800 dark:text-gray-100 pr-2 sm:pr-10 text-right">Status</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in companies" v-bind:class="{ 'bg-gray-200 dark:bg-gray-700': $index % 2 === 0, 'green': $index % 2 !== 0 }" :key="item.id">
              <td class="sm:pl-10 pl-2 pr-2 py-5 text-gray-800 dark:text-gray-100 text-xs sm:text-sm">{{ item.name }}</td>
              <td class="pr-2 py-5 text-gray-800 dark:text-gray-100 text-xs sm:text-sm">{{ item.address }}</td>
              <td class="pr-2 py-5 text-gray-800 dark:text-gray-100 text-xs sm:text-sm text-center">{{ item.email }}</td>
              <td class="py-5 text-green-400 pr-2 sm:pr-10 text-xs sm:text-sm text-right">Active</td>
            </tr>
            </tbody>
          </table>
          <Button label="Download" @click="generatePdf" class="p-button-success" />
        </div>
      </div>
    </Sidebar>
    <Sidebar v-model:visible="fileModal" position="full">
      <Toolbar>
        <template #start>
          <p>Excel faylini yuklash</p>
        </template>

      </Toolbar>
      <div class="w-full h-full bg-gray-200 dark:bg-gray-900 overflow-x-hidden">
        <div class="container mx-auto py-10">
          <Message v-show="notify.show" :severity="notify.severity" :life="10000" :sticky="false">{{ notify.content }}</Message>
          <input type="file" @change="onFileChange" name="file"/>
          <Button label="Load the file" icon="pi pi-upload" iconPos="right" class="p-button-info" :disabled="searchableButton" @click="searchForCompanyByList" /><br>
          <br>
          <label>Reg Number start &nbsp;</label><InputNumber v-model="regNumberStart" /><br>
          <p class="items-center"><ProgressSpinner  v-show="fileLoading"/></p>
        </div>
      </div>
    </Sidebar>


   </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Editor from '@tinymce/tinymce-vue'
import axios from 'axios'
import Sidebar from 'primevue/sidebar';
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Toolbar from 'primevue/toolbar';
import {isEmpty, template} from 'lodash'
import Message from 'primevue/message'
import ProgressSpinner from 'primevue/progressspinner';
import InputNumber from 'primevue/inputnumber';

import readXlsxFile from 'read-excel-file'



export default {
  components: {
    Head,
    Link,
    Sidebar,
    Button,
    InputText,
    LoadingButton,
    Toolbar,
    TextInput,
    'editor': Editor,
    Message,
    ProgressSpinner,
    InputNumber

  },
  layout: Layout,
  remember: 'form',
  props: {
    template: Object,
  },
  data() {
    return {
      loading: true,
      manualModal: false,
      fileModal: false,
      downloadableButton: true,
      searchableButton: true,
      fileLoading: false,
      i: 0,
      form: this.$inertia.form({
        id: this.template.id,
        title: this.template.title,
        content:this.template.content,
      }),
      company: {
        inn: ''
      },
      companies: [],
      notify: {
        show: false,
        severity: '',
        content: ''

      },
      file: null,
      uploadList: null,
      regNumberStart: 1,
    }
  },
  methods: {
    onFileChange(event) {
      let xlsxfile = event.target.files ? event.target.files[0] : null;
      readXlsxFile(xlsxfile).then((rows) => {
        if(rows.length){
          this.notify.show = true
          this.notify.severity = 'success'
          this.notify.content= rows.length +' inn are loaded.'
          this.uploadList = rows
          this.searchableButton = false
        }
      })
    },
    async searchForCompany(){
      axios
        .get('/api/companydetails/'+this.company.inn)
        .catch(function (error) {
          if (error.response === 404) {
            console.log(error.response.message);
            console.log(error.response.status);
          }
        })
        .then(response => {
          if(isEmpty(response)){
            this.notify.show = true
            this.notify.severity = 'warn'
            this.notify.content='Unable to find the company'

          }
          else {
            var isItThere = false
            this.companies.forEach(function (company){
              if(company.inn === response.data.inn)
              {
                isItThere = true
                return false
              }
            })
            if(!isItThere) {
              this.companies.push(response.data)
              this.downloadableButton = false
            }
            else{
              this.notify.show = true
              this.notify.severity = 'warn'
              this.notify.content='Already added'
              this.company.inn = ''
            }
          }
        })
    },
    async searchForCompanyByList(){

      axios({
        url: '/api/companydetailsbylist', //your url
        method: 'POST',
        data: {
          companies: this.uploadList,
          regNumberStart: this.regNumberStart,
          template: this.template.id,
        },
        responseType: 'blob', // important
      }).then((response) => {
        // create file link in browser's memory
        const href = URL.createObjectURL(response.data);

        // create "a" HTLM element with href to file & click
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', 'file.pdf'); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
      });

    },
    generatePdf(){

    },
    showManualModal(){
      this.manualModal  = true
    },
    showFilelModal(){
      this.fileModal  = true
    },
    update() {
      this.form.put(`/templates/${this.template.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this template?')) {
        this.$inertia.delete(`/templates/${this.template.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this template?')) {
        this.$inertia.put(`/templates/${this.template.id}/restore`)
      }
    },
    modalHandler(val) {
      let modal = document.getElementById("modal");
      if (val) {
        this.fadeIn(modal);
      } else {
        this.fadeOut(modal);
      }
    },
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}

</script>
